import Icon from 'assets/images/icons/Icon';
import { images } from 'assets/images/import-images';
import CustomerChat from 'components/common/customer-chat/CustomerChat';
import NewsLetter from 'components/common/newsletter/NewsLetter';
import OpenLink from 'components/common/open-link/OpenLink';
import ServiceTermsCheckout from 'components/common/service-terms-checkout/ServiceTermsCheckout';
import Col from 'components/layout/grid/Col';
import Container from 'components/layout/grid/Container';
import Row from 'components/layout/grid/Row';
import { IS_CORDOVA } from 'constants/constants';
import { politicasDoccuments } from 'constants/doccuments/constants';
import React, { Component } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { PRODUCT_NAMES, RoutesBase } from 'routes/constants-routes';
import { Utils } from 'utils/UtilsDefault';

type Props = {
  context: {
    dispatch(data: any): void;
  };
};

type State = {
  abriChat: boolean;
};

export default class Footer extends Component<RouteComponentProps & Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      abriChat: false,
    };
  }

  openFile(fileUrl) {
    window.open(
      encodeURI(fileUrl),
      '_blank',
      'location=yes,EnableViewPortScale=yes',
    );
  }

  openModal = (): void => {
    $('#ModalCompletePolitica').modal('show');
  };

  render(): JSX.Element {
    const {
      context: { dispatch },
    } = this.props;

    const { abriChat } = this.state;

    const doccuments =
      IS_CORDOVA || Utils.isMobileDevice()
        ? politicasDoccuments['mobile']
        : politicasDoccuments['desktop'];

    /*  eslint-disable jsx-a11y/anchor-is-valid */
    const styleIcons = {
      marginBottom: '5px',
    };
    const styleIconsSocialMedia = {
      marginBottom: '41px',
      marginTop: '5px',
      marginRight: '15px',
    };

    const versionPackage = require("../../../../package.json").version;

    const onClickDispatch = destino => {
      dispatch({
        type: 'SELECT_DESTINATION',
        selectDestination: destino,
      });
      const { history } = this.props;
      window.scrollTo(0, 0);
      history.push(`/`);
    };

    return (
      <footer>
        <Container>
          <Row className="itensFooter" id="rowNewsletter">
            <Col xs="12" sm="4" md="3" lg="3" xl="2">
              <Icon
                name="fadEnvelope"
                width={110}
                fill="#FF5A00"
                style={styleIcons}
              />
            </Col>
            <Col xs="12" sm="8" md="9" lg="9" xl="10" className="Newsletter">
              <h1>
                Faça parte da nossa comunidade e receba ofertas, promoções, dicas e
                roteiros de viagem com exclusividade
              </h1>
              <NewsLetter btnText="Voalá" />
              <div>
                Você receberá e-mails da Voalá e seus dados pessoais não serão
                compartilhados. Para mais informações, consulte as&nbsp;
                <ServiceTermsCheckout />
                {/* <OpenLink to={doccuments.privacidade}>
                  política de privacidade
                </OpenLink> */}
              </div>
            </Col>
          </Row>
          <Row className="itensFooter">
            <hr />
            <Col xs="12" id="iconsSocialMedia">
              <h1 style={{ fontSize: 16, marginTop: 41 }}>
                Siga nossas redes sociais para novidades e conteúdos sobre viagens
              </h1>
              <OpenLink to="https://www.facebook.com/vaidevoala">
                <Icon
                  name="socialFacebook"
                  width={30}
                  style={styleIconsSocialMedia}
                />
              </OpenLink>
              <OpenLink to="https://www.instagram.com/vaidevoala/">
                <Icon
                  name="socialInstagram"
                  width={30}
                  style={styleIconsSocialMedia}
                />
              </OpenLink>
              <OpenLink to="https://www.youtube.com/channel/UCPyKZtYnEo3oMLtWds1IszQ">
                <Icon
                  name="socialYoutube"
                  width={30}
                  style={styleIconsSocialMedia}
                />
              </OpenLink>

              <OpenLink to="https://blog.vaidevoala.com.br/">
                <Icon name="socialBlog" width={30} style={styleIconsSocialMedia} />
              </OpenLink>

              <OpenLink to="https://open.spotify.com/user/dlan9t5o8udpwx2tigfpt79ej">
                <Icon
                  name="socialSpotify"
                  width={30}
                  style={styleIconsSocialMedia}
                />
              </OpenLink>
            </Col>
            <hr />
          </Row>
          <Row className="itensFooter">
            <Col xs="12" sm="12" md="12" lg="3" xl="3">
              <h1>Compre sua viagem</h1>
              <Link to="/" onClick={() => onClickDispatch(PRODUCT_NAMES.package)}>
                Pacotes
              </Link>
              <Link to="/" onClick={() => onClickDispatch(PRODUCT_NAMES.hotel)}>
                Hospedagens
              </Link>
              <Link to="/" onClick={() => onClickDispatch(PRODUCT_NAMES.flight)}>
                Passagens Aéreas
              </Link>
              <Link to="/" onClick={() => onClickDispatch(PRODUCT_NAMES.car)}>
                Carros
              </Link>
              <Link to="/" onClick={() => onClickDispatch('seguro')}>
                Seguros
              </Link>
            </Col>
            <Col xs="12" sm="12" md="12" lg="3" xl="3">
              <h1>Atendimento</h1>
              <p>De segunda a sexta-feira das 9h às 18h</p>
              <OpenLink to="mailto:help@vaidevoala.com.br">
                help@vaidevoala.com.br
              </OpenLink>
              {!IS_CORDOVA && (
                <a
                  onClick={() => this.setState({ abriChat: true })}
                  className="chat text-color-orange"
                >
                  Chat online
                </a>
              )}
            </Col>
            <Col xs="12" sm="12" md="12" lg="3" xl="3" className="info-geral">
              <h1>Informações gerais</h1>
              <OpenLink to={`/${RoutesBase.faq}`} target="_blank">
                Perguntas Frequentes
              </OpenLink>


              {(IS_CORDOVA || Utils.isMobileDevice()) && (
                <>
                  <Link to="/" onClick={() => this.openFile(doccuments.termoUso)}>
                    Termos de Uso
                  </Link>
                  {/* <a onClick={this.openModal}>
                    Política de Privacidade
                  </a> */}
                  <Link to="/" onClick={() => this.openFile(RoutesBase.privacyPolicy)}>
                    Política de Privacidade
                  </Link>
                </>
              )}

              {!IS_CORDOVA && !Utils.isMobileDevice() && (
                <>
                  <OpenLink
                    to={doccuments.termoUso}
                    target="_blank"
                  >
                    Termos de Uso
                  </OpenLink>

                  <OpenLink
                    to={doccuments.privacidade}
                    target="_blank"
                  >
                    Política de Privacidade
                  </OpenLink>
                  {/* <a onClick={this.openModal}>
                    Política de Privacidade
                  </a> */}

                  <OpenLink
                    to={politicasDoccuments['desktop'].cookies}
                    target="_blank"
                  >
                    Política de Cookies
                  </OpenLink>
                </>
              )}
              <OpenLink
                to="https://requisicao-privacidade.bancorbras.com.br"
                target="_blank"
              >
                Formulário de Requisição
              </OpenLink>
            </Col>
            <Col xs="12" sm="12" md="12" lg="3" xl="3" className="pagamentoFooter">
              <h1>Formas de pagamentos / SSL</h1>
              <div>
                <Col>
                  <img
                    src={images.logoCartoesFooter.visa}
                    alt=""
                    height="25px"
                    width="50px"
                  />
                </Col>
                <Col>
                  <img
                    src={images.logoCartoesFooter.mastercard}
                    alt=""
                    height="25px"
                    width="50px"
                  />
                </Col>
                <Col>
                  <img
                    src={images.logoCartoesFooter.elo}
                    alt=""
                    height="25px"
                    width="50px"
                  />
                </Col>
                <Col>
                  <img
                    src={images.logoCartoesFooter.amex}
                    alt=""
                    height="25px"
                    width="50px"
                  />
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="itensFooter">
            <Col xs="12" className="cnpj">
              <div>
                <p>
                  A Voalá é uma agência online que tem como objetivo facilitar o seu
                  planejamento e a compra de uma viagem inesquecível.
                </p>
                <p>Bancorbrás Viagens e Turismo S.A. CNPJ: 24.896.979/0001-96</p>
              </div>
            </Col>
          </Row>
        </Container>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <p>{versionPackage}</p>
        </div>
        {abriChat && <CustomerChat />}
      </footer >
    );
  }
}
